import React, {
  useCallback,
  useState,
  memo,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup, Input, Label } from "reactstrap";

import { showMessage } from "../../../../Libs/CustomMethods/showToast";
import { updateAttachmentStatus } from "../../../../store/attachmentsInteraction/actions";

import "./style.scss";

function FormsAttachmentComponent({ activeChat }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { activeAttachment = null, status: statusReducer = null } =
    useSelector((state) => state.AttachmentsInteraction?.[activeChat]) || {};

  const status = statusReducer?.updateAttachmentStatus;

  const inputRef = useRef(null);

  const [fileStatus, setFileStatus] = useState(
    activeAttachment?.file_status || null
  );
  const [reason, setReason] = useState(activeAttachment?.reason || "");

  const isRejected = fileStatus === "rejected";

  const disableButton = useMemo(() => {
    if (status?.loading) return true;

    if (!activeAttachment) return true;

    if (!fileStatus) {
      return true;
    }

    if (fileStatus === activeAttachment?.file_status) {
      if (fileStatus === "rejected") {
        return reason === activeAttachment?.reason;
      }
      return true;
    }

    return false;
  }, [fileStatus, reason, status?.loading, activeAttachment]);

  const handleFileStatus = useCallback((e) => {
    setFileStatus(e.target.value);
  }, []);

  const handleReason = useCallback((e) => {
    setReason(e.target.value);
  }, []);

  useEffect(() => {
    setFileStatus(activeAttachment?.file_status || null);
    setReason(activeAttachment?.reason || "");
    if (inputRef.current)
      inputRef.current.value = activeAttachment?.reason || "";
  }, [activeAttachment]);

  useEffect(() => {
    if (status?.success) {
      showMessage("success", t("Attachment updated successfully"));
      status.success = false;
    }
    if (status?.error) {
      showMessage("error", t("Error updating attachment"));
      status.error = false;
    }
  }, [status, t]);

  return (
    <div className="forms-attachment-container">
      <Forms
        id={activeAttachment?.id}
        activeChat={activeChat}
        disableButton={disableButton}
        handleFileStatus={handleFileStatus}
        handleReason={handleReason}
        fileStatus={fileStatus}
        isRejected={isRejected}
        activeAttachment={!!activeAttachment}
        inputRef={inputRef}
      />
    </div>
  );
}

export default memo(FormsAttachmentComponent);

const RadioButton = memo(
  ({ name, value, onChange, label, checked = false, disabled }) => (
    <FormGroup check>
      <Label check>
        <Input
          type="radio"
          name={name}
          value={value}
          required
          onChange={onChange}
          checked={checked === value}
          disabled={disabled}
        />
        {label}
      </Label>
    </FormGroup>
  )
);

const Forms = memo(
  ({
    id,
    activeChat,
    disableButton,
    handleFileStatus,
    handleReason,
    fileStatus,
    isRejected,
    activeAttachment,
    inputRef,
  }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleSubmit = useCallback(
      (e) => {
        e.preventDefault();
        const fileStatus = e.target.fileStatus.value;
        let reason = null;

        reason = e.target.reason.value;

        dispatch(updateAttachmentStatus({chatId: activeChat, interactionId: id, fileStatus, reason}));
      },
      [dispatch, activeChat, id]
    );

    return (
      <form onSubmit={handleSubmit}>
        <RadioButton
          name="fileStatus"
          value={"approved"}
          onChange={handleFileStatus}
          label={t("Approve")}
          checked={fileStatus}
          disabled={!activeAttachment}
        />
        <RadioButton
          name="fileStatus"
          value={"rejected"}
          onChange={handleFileStatus}
          label={t("Reject")}
          checked={fileStatus}
          disabled={!activeAttachment}
        />
        <div className={`input-component`}>
          <label htmlFor={"input-reason"} className="label">
            {t("Reason")}
            <span className="required">*</span>
          </label>
          <input
            name={"reason"}
            id={"input-reason"}
            required={isRejected}
            placeholder={isRejected ? t("Enter the reason for rejection") + "..." : t("Enter the reason for aprove") + "..." }
            onChange={handleReason}
            ref={inputRef}
            maxLength="200"
          />
        </div>
        <input
          className="btn btn-primary"
          type="submit"
          value={t("Concluded")}
          disabled={disableButton}
        />
      </form>
    );
  }
);
